
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';


const initialState = {
	isLoading: false,
	error: null,
	promos: [],
	promo: null,
};

const slice = createSlice({
	name: 'promo',
	initialState,
	reducers: {
		// START LOADING
		startLoading(state) {
			state.isLoading = true;
		},

		// HAS ERROR
		hasError(state, action) {
			state.isLoading = false;
			state.error = action.payload;
		},

		// GET PRODUCTS
		getPromosSuccess(state, action) {
			state.isLoading = false;
			state.promos = action.payload;
		},

	},
});


// ----------------------------------------------------------------------

// Reducer
export default slice.reducer;


/* export function getPromos() {
	return async (dispatch) => {
		dispatch(slice.actions.startLoading());
		try {
			// const response = await axios.get('/api/products');
			dispatch(slice.actions.getPromosSuccess(arr));
		} catch (error) {
			dispatch(slice.actions.hasError(error));
		}
	};
} */

export function getPromos() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/promos');
      dispatch(slice.actions.getPromosSuccess(response.data.promos));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------